import React, { useState } from 'react';
import './ImageGallery.css'

function Gallery({ImageURLs = ['/CookieMissingTexture.png', '/CookieMissingTexture.png']}, ImageAlts = []) {
    const [ImageNum, SetImgNum] = useState(0);

    const NextSlide = () => {
        SetImgNum((ImageNum === (ImageURLs.length - 1)) ? 0 : (ImageNum + 1));
    }
    const PrevSlide = () => {
        SetImgNum((ImageNum === 0) ? (ImageURLs.length - 1) : (ImageNum - 1));
    }
    if (!Array.isArray(ImageURLs)) {
        return (
            <img src="/CookieMissingTexture.png" alt='Missing Cookie Texture'/>
        );
    }
    var missingno = 1;
    while(ImageAlts < ImageURLs) {
        ImageAlts.push("Missing Alt" + missingno);
    }
    var CurrImg = (
        <img
            src={ImageURLs[ImageNum]}
            alt={ImageAlts[ImageNum]}
        />
    );

    return(
        <div className="GalleryImages">
            <button className='ScrollSlidePrev' onClick={PrevSlide}>&lt;</button>
            {CurrImg}
            <button className='ScrollSlideNext' onClick={NextSlide}>&gt;</button>
        </div>
    );
}

export default Gallery